import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc filter
     * @name pkpSlashLinebreak
     * @memberof app
     *
     * @description
     * Adds after a every slash in a string a zero width whitespace,
     * so these will be the preferable breaking points in a connected
     * string.
     *
     * @returns {string}
     *
     * @author somarten.btc
     */
    angular.module('app').filter('pkpSlashLinebreak', pkpSlashLinebreak);

    function pkpSlashLinebreak() {
        return function (input) {
            if (!input) {
                return input;
            }
            return input.replace(/[\/]/g, '/' + '\u200b');
        };
    }
})();
